module.exports = __webpack_public_path__ + "img/myjb.aa7ddb10.png";